module.exports = __webpack_public_path__ + "static/media/incident-blue.7c670f9b.svg";